module.exports = __webpack_public_path__ + "0c9e72d2c0d8e7e8eaa27fa7b444e3e7.png";